var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStore = function SvgStore(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#store_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9 9.4c-.1-.57-2.78-7.5-2.88-7.75A1 1 0 0 0 23.1 1H4.9a1 1 0 0 0-.93.65c-.1.26-2.77 7.18-2.89 7.75a4.5 4.5 0 0 0 .94 3.75c.26.32.65.6.97.84V26a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V13.99c.32-.25.7-.52.97-.84a4.5 4.5 0 0 0 .94-3.75ZM16 25h-4v-5h4v5Zm7 0h-5v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6H5V14.9A4.83 4.83 0 0 0 9.91 13a5.17 5.17 0 0 0 8.18 0A4.83 4.83 0 0 0 23 14.9V25Zm1.41-13.11A3.21 3.21 0 0 1 22 13a3 3 0 0 1-3-3 1 1 0 0 0-2 0 3 3 0 0 1-6 0 1 1 0 0 0-2 0 3 3 0 0 1-3 3c-.89 0-1.85-.42-2.41-1.11a2.47 2.47 0 0 1-.54-2.09C3.16 9.27 5.51 3.24 5.6 3h16.8c.1.24 2.44 6.27 2.55 6.8.15.74-.04 1.48-.54 2.09Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "store_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgStore;